import Header from '@/components/layout/Header'

import subject from './subject'
import team from './team'
import site from './site'
import design from './design'
import query from './query'
import diff from './diff'
import lb from './lb'
import stat from './stat'
import expt from './export'

const Study = () => import(/* webpackChunkName: "study-group" */ '@/views/study/Study')
const ViewStudy = () => import(/* webpackChunkName: "study-group" */ '@/views/study/ViewStudy')
const StudySurvey = () => import(/* webpackChunkName: "study-group" */ '@/views/study/StudySurvey')

var routes = [
  { path: '', name: 'study-survey', components: { studyContent: StudySurvey }, meta: { title: '研究概况' } }
]

routes = routes.concat(subject)
routes = routes.concat(team)
routes = routes.concat(site)
routes = routes.concat(design)
routes = routes.concat(query)
routes = routes.concat(diff)
routes = routes.concat(lb)
routes = routes.concat(stat)
routes = routes.concat(expt)

export default [
  {
    path: '/study',
    name: 'study',
    components: {
      header: Header,
      main: Study
    },
    meta: {
      title: '临床研究'
    }
  },
  {
    path: '/study/:id',
    name: 'view-study',
    components: {
      header: Header,
      main: ViewStudy
    },
    meta: {
      title: '临床研究'
    },
    redirect: { name: 'study-survey' },
    children: routes
  }
]
